import React, { useRef, useEffect, useCallback } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  ${({ orientation }) => orientation === 'vertical' || !orientation
  ? `
    height: 100%;
    overflow: auto;
  `
  : `
    width: 100%;
    height: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    display: flex;
  `}

  ${({ disableScrolling }) => disableScrolling && 'overflow: hidden;'}
`

const Marker = styled.div`
  ${({ orientation }) => orientation === 'vertical' || !orientation
  ? `
    height: 5px;
  `
  : `
    margin-left: -5px;
  `}
`

export const ScrollObserver = ({
  children,
  disableScrolling,
  onMaxScroll,
  orientation
}) => {
  const markerRef = useRef()
  const rootRef = useRef()
  const intersectionObserver = useRef()

  useEffect(() => {
    intersectionObserver.current = new IntersectionObserver(onIntersection, {
      root: rootRef.current,
      threshold: 0
    })
    intersectionObserver.current.observe(markerRef.current)

    return () => {
      intersectionObserver.current.disconnect()
    }
  }, [markerRef.current])

  const onIntersection = useCallback(entries => {
    const [firstEntry] = entries
    if (firstEntry.isIntersecting) {
      onMaxScroll()
    }
  }, [onMaxScroll])

  return (
    <Container
      disableScrolling={disableScrolling}
      ref={rootRef}
      orientation={orientation}
    >
      {children}
      <Marker
        ref={markerRef}
        orientation={orientation}
      />
    </Container>
  )
}

ScrollObserver.defaultProps = {
  onMaxScroll: () => { }
}

export default ScrollObserver
